import spriteManifest from '../../game/spriteManifest.json'

type Obj = Record<string, unknown>

function asObj(v: unknown): Obj {
  return typeof v === 'object' && v !== null && !Array.isArray(v) ? (v as Obj) : {}
}

/** The single image of a manifest kind (`art.default.src`), or null when the art is missing. */
export function kindImage(manifest: unknown, kind: string): string | null {
  const src = asObj(asObj(asObj(asObj(manifest)[kind]).art).default).src
  return typeof src === 'string' && src !== '' ? src : null
}

/** A ride's round icon (`ride_icon_<id>`, A-29) for the hub, or null (placeholder disc). */
export function rideIcon(id: string): string | null {
  return kindImage(spriteManifest, `ride_icon_${id}`)
}

/** A ride's side view (`ride_<id>`, A-23 … A-28), or null. */
export function rideImage(id: string): string | null {
  return kindImage(spriteManifest, `ride_${id}`)
}
